module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-02.48215191.png";